module.exports = __webpack_public_path__ + "apple.svg?ae57cfaa5e67a5ffdfcf8ef6ad59a859";